import { OrderHeaderURLs } from '../../../../baseComponents/TwinTable/InputTableLayout/types'

const useBuyOrderHeaderURLs = () => {
    const orderHeaderURLs: OrderHeaderURLs = {
        createCost: '/api/app/order/buy/buyOrder/orderCost/createBuyOrderCost',
        updateCost: '/api/app/order/buy/buyOrder/orderCost/updateBuyOrderCost',
        deleteCost: '/api/app/order/buy/buyOrder/orderCost/deleteBuyOrderCost',
        createFinancialRow: '/api/app/order/buy/buyOrder/orderFinancialRow/createBuyOrderFinancialRow',
        updateFinancialRow: '/api/app/order/buy/buyOrder/orderFinancialRow/updateBuyOrderFinancialRow',
        deleteFinancialRow: '/api/app/order/buy/buyOrder/orderFinancialRow/deleteBuyOrderFinancialRow',
        createAccount: '/api/app/order/buy/buyOrder/orderAccount/createBuyOrderAccount',
        updateAccount: '/api/app/order/buy/buyOrder/orderAccount/updateBuyOrderAccount',
        deleteAccount: '/api/app/order/buy/buyOrder/orderAccount/deleteBuyOrderAccount',
        createShipping: '/api/app/order/buy/shipping/createBuyShippingForOrder',
        updateShipping: '/api/app/order/buy/shipping/updateBuyShippingOrder',
        createVariable: '/api/app/order/buy/buyOrder/orderVariable/createBuyOrderVariable',
        updateVariable: '/api/app/order/buy/buyOrder/orderVariable/updateBuyOrderVariable',
        deleteVariable: '/api/app/order/buy/buyOrder/orderVariable/deleteBuyOrderVariable',
        updateWorkingCenter: '/api/app/order/buy/buyOrder/updateBuyOrderWorkingCenter',
        createUpdateProductTypes: '/api/app/order/buy/buyOrder/orderProductType/createUpdateBuyOrderProductTypes',
    }
    return orderHeaderURLs
}

export default useBuyOrderHeaderURLs